import React from "react";
import { Alert } from "antd";
import styles from "./SearchHintContent.module.css";

const SEARCHABLE_FIELD_COLUMNS: string[][] = [
  ["Business name", "User name", "User email"],
  ["Business ID", "Business Trade name"],
  ["MID", "KVK"],
];

const PREFIX_SEARCHES: { key: string; label: string; example: string }[] = [
  { key: "sn:", label: "Device serial number", example: "sn:30025551" },
  {
    key: "sna:",
    label: "Active device serial number",
    example: "last online within 7 days",
  },
  { key: "v:", label: "Device build version", example: "v:2.8.1" },
];

const SearchHintContent: React.FC = () => {
  return (
    <div
      className={styles.container}
      onMouseDown={(e) => e.preventDefault()}
    >
      <Alert
        type="info"
        showIcon
        message={
          <span>
            Use special prefix search - e.g. <code>sn:30025551</code> to find
            a merchant by terminal serial number.
          </span>
        }
        className={styles.alert}
      />

      <div className={styles.sectionLabel}>SEARCHABLE FIELDS</div>
      <div className={styles.fieldsColumns}>
        {SEARCHABLE_FIELD_COLUMNS.map((column, idx) => (
          <div key={idx} className={styles.fieldsColumn}>
            {column.map((field) => (
              <div key={field} className={styles.fieldItem}>
                <span className={styles.fieldBullet}>•</span>
                {field}
              </div>
            ))}
          </div>
        ))}
      </div>

      <div className={styles.sectionLabel}>SPECIAL PREFIX SEARCHES</div>
      <div className={styles.prefixBox}>
        {PREFIX_SEARCHES.map(({ key, label, example }) => (
          <React.Fragment key={key}>
            <div className={styles.prefixKey}>{key}</div>
            <div className={styles.prefixLabel}>{label}</div>
            <div className={styles.prefixExample}>{example}</div>
          </React.Fragment>
        ))}
      </div>

      <div className={styles.footer}>
        Press<span className={styles.enterKey}>↵</span>Enter to search
      </div>
    </div>
  );
};

export default SearchHintContent;
